import dayjs from 'dayjs'

/**
 * Mock Sentry Issues Data - BackOffice Workstream
 * Matches the actual API response structure
 */
export const mockSentryIssuesBackoffice = {
  success: true,
  issues: [
    {
      id: '6843177810',
      title: 'ValidationError: Invalid lane schedule format',
      culprit: '/backoffice/lane-schedules/create',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'ValidationError',
        value: 'Invalid lane schedule format',
        type: 'ValidationError',
        filename: 'LaneSchedule.tsx',
        function: 'validateSchedule',
        in_app_frame_mix: 'in-app-only',
      },
      numComments: 3,
      userCount: 6,
      count: 52,
      firstSeen: dayjs().subtract(1, 'month').toISOString(),
      lastSeen: dayjs().subtract(2, 'hours').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177810/',
      shortId: 'BACKOFFICE-1D1',
      project: {
        id: '4507465295659002',
        name: 'backoffice',
        slug: 'backoffice',
        platform: 'javascript-react',
      },
      assignedTo: {
        type: 'user',
        name: 'Jane Smith',
        email: 'jane.smith@daylight.com',
      },
      isBookmarked: true,
      isSubscribed: true,
      isUnhandled: true,
      hasSeen: true,
      annotations: [],
      logger: '',
      priority: 'high',
      filtered: {
        count: 52,
        userCount: 6,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(2, 'hours').toISOString(),
      },
      lifetime: {
        count: 52,
        userCount: 6,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(2, 'hours').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
    {
      id: '6843177811',
      title: 'SyntaxError: Unexpected token in JSON at position 145',
      culprit: '/backoffice/api/shipments/update',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'SyntaxError',
        value: 'Unexpected token in JSON at position 145',
        type: 'SyntaxError',
        filename: 'JSON.parse',
        function: 'parse',
        in_app_frame_mix: 'system-only',
      },
      numComments: 1,
      userCount: 4,
      count: 28,
      firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
      lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177811/',
      shortId: 'BACKOFFICE-2E2',
      project: {
        id: '4507465295659002',
        name: 'backoffice',
        slug: 'backoffice',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: false,
      isSubscribed: false,
      isUnhandled: true,
      hasSeen: false,
      annotations: [],
      logger: '',
      priority: 'medium',
      filtered: {
        count: 28,
        userCount: 4,
        firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      },
      lifetime: {
        count: 28,
        userCount: 4,
        firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      },
      enrichedEnvironment: 'QA',
    },
  ],
  pagination: {
    nextCursor: null,
    hasMore: false,
    recordCount: 2,
  },
  'x-hits': 2,
  recordCount: 2,
}

export const mockPriorityCountsBackoffice = {
  success: true,
  'priority-counts': {
    high: 1,
    medium: 1,
    low: 0,
  },
  'x-hits': 2,
}
